import React from "react";
import { BsGithub, BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import "./SocialMedia.css";

const SocialMedia = () => {
  return (
    <div className="app__social">
      {/* <div>
        <a
          href="https://www.linkedin.com/in/dejan-robi-ab426b232/"
          target={"_blank"}
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://github.com/Dejanrobi" target={"_blank"}>
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="https://twitter.com/dejan_robi" target={"_blank"}>
          <BsTwitter />
        </a>
      </div> */}
      <div>
        <a
          href="https://www.facebook.com/dejan.robi.311/"
          target={"_blank"}
        >
          <FaFacebook />
        </a>
      </div>
      {/* <div>
        <a href="https://www.instagram.com/dejanrobi/" target={"_blank"}>
          <BsInstagram />
        </a>
      </div> */}
    </div>
  );
};

export default SocialMedia;
